export default __webpack_public_path__ + "static/media/teams.fd99334a.png";